module.exports = __webpack_public_path__ + "img/four2Blue.29f67e48.jpg";